if ( typeof HerbaZestCountdownClock !== 'function' ) {

  class HerbaZestCountdownClock extends HTMLElement {

    constructor(){
      super();
      this.init();
    }

    init(){

      // this.daysEl = this.querySelector('.days');
      // this.deliverydateEl = this.querySelector('.delivery-date');
      this.hoursEl = this.querySelector('.hours');
      this.minutesEl = this.querySelector('.minutes');
      this.secondsEl = this.querySelector('.seconds');

      this.lang = this.dataset.lang;
      this.dayslist = this.dataset.dayslist.split(',');
      this.monthslist = this.dataset.monthslist.split(',');
      
      // const deliverydate = this.dataset.deliverydate.split(',');
      // this.DELIVERYDATE = new Date(deliverydate[0], (deliverydate[1]-1), deliverydate[2]);
// console.log(this.DELIVERYDATE);
      const date = this.dataset.date.split(',');
      this.COUNT = new Date(date[0], (date[1]-1), date[2], date[3], date[4]);
// console.log(this.COUNT);
      const gmt = parseInt(this.dataset.timezone);
      const timezone = this.COUNT.getTimezoneOffset() / -60;

      if ( timezone != gmt ) {
        this.COUNT.setHours(parseInt(date[3]) + timezone - gmt );
      } 

      this._countdownBannerInterval = setInterval(this._countEachSecond.bind(this), 1000);
      this._countEachSecond();
      if ( this.classList.contains('hide') ) {
        this.classList.remove('hide');
      }
    }

    _countEachSecond(){

      const now = new Date().getTime(),
        distance = this.COUNT - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // this.daysEl.innerHTML = days < 10 ? `<span>0</span><span>${days}</span>` : days.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      // this.hoursEl.innerHTML = hours < 10 ? `<span>0</span><span>${hours}</span>` : hours.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      // this.minutesEl.innerHTML = minutes < 10 ? `<span>0</span><span>${minutes}</span>` : minutes.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      // this.secondsEl.innerHTML = seconds < 10 ? `<span>0</span><span>${seconds}</span>` : seconds.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      this.hoursEl.innerHTML = hours.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      this.minutesEl.innerHTML = minutes.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      this.secondsEl.innerHTML = seconds.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      if ( hours < 1 ) {
        this.hoursEl.parentElement.classList.add('hide');
        this.minutesEl.classList.add('no-time-separator');
      }
      else {
        this.hoursEl.parentElement.classList.remove('hide');
        this.minutesEl.classList.remove('no-time-separator');
      }
      if ( minutes < 1 ) {
        this.minutesEl.parentElement.classList.add('hide');
        this.secondsEl.parentElement.classList.remove('hide');
        this.secondsEl.classList.add('no-time-separator');
      }
      else {
        this.minutesEl.parentElement.classList.remove('hide');
        this.secondsEl.parentElement.classList.add('hide');
        this.secondsEl.classList.remove('no-time-separator');
      }

      if ( distance < 0 ) {
        // this.DELIVERYDATE.setDate(this.DELIVERYDATE.getDate() + 1)
        // console.log(this.DELIVERYDATE);
        // this.deliverydateEl.innerHTML = this.lang == 'en' 
        //                                   ? this.dayslist[this.DELIVERYDATE.getDay()] + ', ' + this.monthslist[this.DELIVERYDATE.getMonth()] + ' ' + this.DELIVERYDATE.getDate()
        //                                   : this.dayslist[this.DELIVERYDATE.getDay()] + ' ' + this.DELIVERYDATE.getDate() + ' de ' + this.monthslist[this.DELIVERYDATE.getMonth()];
        
        clearInterval(this._countdownBannerInterval);
        // this.daysEl.innerHTML = '<span>0</span><span>0</span>';
        // this.hoursEl.innerHTML = '<span>0</span><span>0</span>';
        // this.minutesEl.innerHTML = '<span>0</span><span>0</span>';
        // this.secondsEl.innerHTML = '<span>0</span><span>0</span>';
        this.hoursEl.innerHTML = '<span>&ndash;</span>';
        this.minutesEl.innerHTML = '<span>&ndash;</span>';
        this.secondsEl.innerHTML = '<span>&ndash;</span>';
      }
    }

  }

  if ( typeof customElements.get('herbazest-countdown-clock') == 'undefined' ) {
    customElements.define('herbazest-countdown-clock', HerbaZestCountdownClock);
  }

}